
(function(template){
define('vue!basicComponents/inputIconField',['Vue'],function(Vue){
    return {
        template: template,
        props: ['text','type','placeholder','id','ariaLabel'],
    }
})
})('<div class="customIconInput"> <input :type="type || \'text\'" :id="id" :placeholder="placeholder" :aria-label="ariaLabel" :value="text" @input="$emit(\'update:text\',$event.target.value)" /> <slot name="icon"></slot> </div>');
